/* eslint-disable import/extensions */

import React from 'react';
import {
    createRoot
} from 'react-dom/client';

import CompanySetManager from './CompanySetManager.jsx';


RivalIQ.apps.Shell.module('components', function (components, App, Backbone, Marionette, $, _) {
    'use strict';

    // This component is a bridge between Marionette and the React-based company set manager.
    components.CompanySetManagerContainerView = Marionette.LayoutView.extend({
        className: 'modal',

        template: function () {
            return '<div class="modal-dialog modal-lg"><div class="modal-content"><div class="react-container"></div></div></div>';
        },

        attributes: {
            'data-keyboard': false,
            tabindex: '-1',
            'data-backdrop': 'static' // don't allow closing the modal by clicking next to it.
        },

        ui: {
            reactContainer: '.react-container'
        },

        onRender: function () {
            const me = this;

            const focusCompanyId = RivalIQ.state.view.get('focusCompanyId');
            const companies = RivalIQ.state.landscape.get('companies').map(company => {
                const companyId = company.get('id');
                return {
                    id: companyId,
                    name: company.get('name'),
                    iconUrl: company.getIcon(),
                    isFocusCompany: companyId === focusCompanyId
                };
            });

            const element = (
                <React.StrictMode>
                    <CompanySetManager
                        companies={companies}
                        onCloseModal={() => me.$el.modal('hide')}
                    />
                </React.StrictMode>
            );

            if (!me.reactRoot) {
                me.reactRoot = createRoot(me.ui.reactContainer[0]);
            }
            me.reactRoot.render(element);

            me.$el.on('hide.bs.modal', me.onHide.bind(me));
        },

        onShow: function () {
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ViewedTagManager);
        },

        onHide: function () {
            const me = this;

            if (me.reactRoot) {
                me.reactRoot.unmount();
                me.reactRoot = null;
            }

            RivalIQ.state.companySets.trigger('companySetEditingComplete');
        }
    });

});
